function redrawArea(elements) {
    elements.forEach(function(element) {
        let items = element.querySelectorAll('.js-unify-height-item');
        redraw(items);
    });
}

function redraw(elements) {
    let height = -1;

    elements.forEach(function (element) {
        element.style.height = '';
    });

    elements.forEach(function (element) {
        if(height < element.offsetHeight) {
            height = element.offsetHeight;
        }
    });

    elements.forEach(function (element) {
        element.style.height = height+'px';
    });
}

export function applyTo(selector) {
    let elements = document.querySelectorAll(selector);

    redrawArea(elements);

    window.addEventListener('resize', function() {
        redrawArea(elements);
    });
}

export function applyDataAttribute() {
    let elements = document.querySelectorAll('[data-unify-height]');
    let groups = [];
    let elementsGroups = [];

    elements.forEach(function(item) {
        let groupName = item.getAttribute('data-unify-height');
        let groupKey = groups.indexOf(groupName);

        if(groupKey < 0) {
            groupKey = groups.push(groupName) - 1;
        }


        if(elementsGroups[groupKey] === undefined) {
            elementsGroups[groupKey] = [];
        }

        elementsGroups[groupKey].push(item);
    });

    elementsGroups.forEach(function(elements) {
        redraw(elements);
    });

    window.addEventListener('resize', function() {
        elementsGroups.forEach(function(elements) {
            redraw(elements);
        });
    });

    window.addEventListener('shown.bs.tab', function() {
        elementsGroups.forEach(function(elements) {
            redraw(elements);
        });
    });
}
